<template>
  <v-card class="fluid-column ma-5">

    <v-card-item>
      <v-card-title class="text-headline-small">Devel 🔴🟠🟡🟢🔵</v-card-title>
    </v-card-item>

    <v-card-text>
      <p class="text-headline-small mt-5">Picker - to do 2026</p>
      <ul>
        <li class="text-decoration-line-through">
          🚧 Visualizzare etichette sugli oggetti a zoom alto
        </li>
        <li class="text-decoration-line-through">
          🚧 Su "info" far sparire l'interfaccia, solo "mobile"
        </li>
        <li class="text-decoration-line-through">
          🚧 Aumentare lo zoom possibile (controllare che succede sulle mappe)
        </li>
        <li>
          🚧 Punti preferiti stellina/altro
        </li>
        <li  class="text-decoration-line-through">
          🚧 Rilievo Fitosociologico, ordinare i taxa RACCOLTI per AZ
        </li>
        <li class="text-decoration-line-through">
          🚧 Rilievo Fitosociologico, permettere sconosciuto multipli?
        </li>
        <li class="text-decoration-line-through">🚧 Aumentare zoom possibile</li>
        <li>🚧 Punti stellina sincronizzati, pubblici e privati. Icona?</li>
        <li class="text-decoration-line-through">🚧 Rilievo Fito, ordinare per AZ i taxa</li>
        <li class="text-decoration-line-through">🚧 Rilievo Fito, sconosciuto multiplo</li>
        <li>🚧 Monticanti</li>
        <li>🚧 Cambio mail</li>
        <li>⭐️ Sorgenti? (non approfondito, per ora punto)</li>
        <li>⭐️ build creare TUTTE le immagini una volta sola (creare script per npm a rimuoverlo dal build) sola e capire come
          iniettarle correttamente nel vite.config (usare ENVIRONMENT nel path in buonissima sostanza)</li>
        <li>⭐️ il btn "nextFeature" scatena 3 sessionSave... un po' troppi<br>
            pensare a un debouncer per il save session (max saves one every 500ms eg)?
        </li>
        <li>⭐️ packs - mostrare l'avanzamento download</li>
        <li>⭐️ migliorare export files (zip con metadata.json + binary files)</li>
        <li>⭐️ inserimento layer geojson a volontà da admin (o da pwa?) su tabelle su tracker.pngp.it<br></li>
        <li>⭐️ lista dei taxa (da Chlorophyll) a bordo,<br>
          con numero segnalazioni per quadrante UTM32632 4km UTM<br>
          e icona per visualizarlo per quadrante<br>
          strategia di update<br>
          usare convalida per filtrare (dubbio errato)<br>
          Lista taxa con icone o evidenziazioni per attributi taxa
        </li>
        <li>⭐️ Appunti online con stellina synced</li>
        <li>⭐️ Geometry UNDO in modifica</li>
        <li>⭐️ Debuggable production</li>
      </ul>
      <p class="text-headline-small mt-5">Tracker</p>
      <ul>
        <li>⭐️ admin segmenti / tracce / segnalazioni - migliorare</li>
      </ul>



      <p class="text-headline-small mt-5">Chlorophyll</p>

      <ul class="mt-5">
        <li>🪲 nel trigger dove stampa { { taxa } } (quale era...?)</li>
        <li>🪲 gestire / indagare exceptions
          <br> causati da tentativi import doppi
        </li>
        <li>🪲 OGR error in staging ?
        </li>
        <li>🚧 Export csv della left join di rilievofito (multiplo, capire dove/come) e sue segnalazioni
          <br>già fatto, selezionare i campi corretti
          <br>OPPURE, meglio, usare la vista
        </li>
        <li>🚧 Export Multiplo Fitosociologia, come farlo?
          <br>usare la vista, finire di compilarla per bene...
          <br>anzi, farne 2, una con gli id, l'altra con solo le rappresentazioni
        </li>
        <li>🚧 Import CSV esportato da Picker - Fitosociologia
        </li>
      </ul>
    </v-card-text>

    <v-card-text>
      <p class="text-headline-small mt-5">Maybe</p>
      <ul>
        <li>⭐️ speech recognition</li>
        <li>⭐️ on board AI ✨</li>
        <li>⭐️ cambio di proiezione <br>
          - https://openlayers.org/en/latest/examples/projection-and-scale.html<br>
          - https://openlayers.org/en/latest/examples/reprojection-by-code.html
        </li>
        <li>⭐️ AI recognition <br>
          - https://plantnet.org/en/ <br>
          - https://my-api.plantnet.org/?tags=my-api#/my-api/getV2IdentifyProject
        </li>
      </ul>
    </v-card-text>

    <v-card-text>
      <p class="text-headline-small mt-5">Checklist</p>
      <ul>
        <li>
          <v-icon>mdi-flask</v-icon>
          Tests e2e
        </li>
        <li>
          <v-icon>mdi-desktop-classic</v-icon>
          Try on browsers
          <ul>
            <li>
              Firefox
            </li>
            <li>
              Edge
            </li>
            <li>
              Safari
            </li>
          </ul>
        </li>
      </ul>

      <p class="mt-5">Legenda</p>
      <ul class="">
        <li>🐞 serious bug</li>
        <li>🪲 bug</li>
        <li>🚧 to do to deliver</li>
        <li>⭐️ feature to be implemented</li>
      </ul>

    </v-card-text>


    <v-card-text>
      <p class="text-headline-small mt-5">Links utili</p>
      <ul class="pl-6">
        <li><a href="https://vite-pwa-org.netlify.app/workbox/generate-sw.html" target="_blank">pre cache pwa</a></li>
        <li><a href="https://openlayers.org/en/latest/examples/regularshape.html" target="_blank">stars</a></li>
        <li><a href="https://developer.mozilla.org/en-US/docs/Web/API/Web_Share_API" target="_blank">Web_Share_API</a>
        </li>
        <li><a href="https://vue3openlayers.netlify.app/get-started.html" target="_blank">vue3openlayers</a></li>
        <li><a href="https://gitlab.com/gromish/tracker" target="_blank">git</a></li>
        <li><a href="https://whatpwacando.today/" target="_blank">pwa</a></li>
        <li> <a href="https://vue3openlayers.netlify.app/componentsguide/interactions/modify/" target="_blank">vue3
            interaction</a></li>
        <li><a href="https://dev.to/ruppysuppy/7-more-javascript-web-apis-to-build-futuristic-websites-you-didnt-know-50bg"
              target="_blank">web-apis</a></li>
        <li><a href="https://simpleicons.org/" target="_blank">simpleicons.org</a></li>
      </ul>
    </v-card-text>

  </v-card>
</template>

<script setup>



</script>

<style scoped>
ul {
  padding-left: 20px;
}
</style>
